import './NotFound.scss';

import React from 'react';

import { ReactComponent as Rebranding404Error } from '../../assets/rebranding/feedback/global-errors/falha-loading.svg';
import { Link } from '@icarros/ids-react';

export function NotFound() {
  return (
    <div className="not-found main-content">
      <div className="not-found__content">
        <span className="not-found__title">oops, algo deu errado...</span>
        <span className="not-found__subtitle">
          tente novamente mais tarde ou entre em contato com o nosso canal de atendimento pelo{' '}
          <Link href="mailto:faleconosco@icarros.com.br">faleconosco@icarros.com.br</Link>
        </span>
        <Rebranding404Error />
      </div>
    </div>
  );
}
